import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { i18n } from '@/utils/i18n';

const claimNpoSchema = Yup.object().shape({
  firstName: Yup.string().required(i18n.t('claim_npo.required_firstName')),
  lastName: Yup.string().required(i18n.t('claim_npo.required_lastName')),
  npoName: Yup.string().required(i18n.t('claim_npo.required_npoName')),
  email: Yup.string().required(i18n.t('claim_npo.required_email')).email(i18n.t('mix.valid_email')),
  phone: Yup.string().required(i18n.t('claim_npo.required_phone')),
  driverLicense: Yup.mixed<File | string>().required(i18n.t('claim_npo.required_driverLicense')),
  articlesOfIncorporation: Yup.mixed<File | string>().required(i18n.t('claim_npo.required_articlesOfIncorporation'))
});

// Types
export type ClaimNpoData = Yup.InferType<typeof claimNpoSchema>;

// Resolvers
export const claimNpoResolver = yupResolver(claimNpoSchema);
